<template>
  <div id="smartTown">
    <div class="title">医院智慧管理分级评估标准体系（试行）</div>
    <div class="text">医院智慧管理是“三位一体”医疗健康建设的重要组成部分。为指导各地、各医院加强医疗健康建设的顶层设计，充分利用智慧管理工具，提升医院管理精细化、智能化水平，特制定医院智慧管理分级评估标准体系。</div>
    <div class="btn" @click="toLink()">查看详情</div>
   
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('http://www.nhc.gov.cn/yzygj/s3594q/202103/10ec6aca99ec47428d2841a110448de3.shtml')
    }
  }
};
</script>
<style scoped>
.btn{
  margin: 40px auto 20px;
  display: block;
  border-radius: 4px;
  width: 80px;
  color: #1e73be;
  border: 1px solid #1e73be;
}

.btn:hover{
  color: #1e73be ;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 15px;
  margin-right: 20px;
  text-indent: 28px
}
.sub-title{
  color: #666;
  font-size: 18px;
  text-align: center;
}
.right{
  text-align: right;
  color: #666;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
}
.title1{
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/view/news8.vue